import { styled } from '@mui/material/styles';

// The tab strip sits between DialogHeader and DialogContent, so it owns the dialog's horizontal
// padding itself and carries the rule that separates it from the panel below.
export const SummaryDashboardEditDialogTabs = styled('div')(({ theme }) => ({
  borderBottom: `var(--dialog-border-width) solid ${theme.palette.neutral[200]}`,
  boxSizing: 'border-box',
  padding: `${theme.spacing(2)} var(--dialog-padding)`,
}));

export const SummaryDashboardEditDialogSection = styled('section')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1),
}));

export const SummaryDashboardEditDialogSectionTitle = styled('h3')(({ theme }) => ({
  color: theme.palette.neutral[500],
  fontSize: '11px',
  fontWeight: theme.typography.fontWeightMedium,
  letterSpacing: '0.06em',
  lineHeight: '16px',
  margin: 0,
  textTransform: 'uppercase',
}));

export const SummaryDashboardEditDialogRows = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1.5),
}));

export const SummaryDashboardEditDialogRow = styled('div')(({ theme }) => ({
  // `start` rather than `baseline`: a control column can be several rows tall (an ordered metric
  // list, a filter repeater) and the label should sit at its top, not float to its last line.
  alignItems: 'start',
  display: 'grid',
  gap: theme.spacing(2),
  // A single column below sm: the label/control pair wraps rather than squeezing a select into a
  // narrow gutter.
  gridTemplateColumns: 'minmax(0, 1fr)',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'minmax(0, 160px) minmax(0, 1fr)',
  },
}));

export const SummaryDashboardEditDialogRowLabel = styled('div')(({ theme }) => ({
  color: theme.palette.neutral[500],
  fontSize: 'var(--dialog-description-font-size)',
  lineHeight: 'var(--dialog-description-line-height)',
  margin: 0,
  overflowWrap: 'anywhere',
  // Nudged down so a label lines up with the text inside its control rather than the border above it.
  [theme.breakpoints.up('sm')]: {
    paddingTop: theme.spacing(1),
  },
}));

export const SummaryDashboardEditDialogRowControl = styled('div')({
  display: 'grid',
  gap: '4px',
  minWidth: 0,
});

export const SummaryDashboardEditDialogRowHelper = styled('p')(({ theme }) => ({
  color: theme.palette.neutral[500],
  fontSize: '11px',
  lineHeight: '16px',
  margin: 0,
}));

export const SummaryDashboardEditDialogSectionHeader = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
}));

export const SummaryDashboardEditDialogBody = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3),
}));

export const SummaryDashboardEditDialogIssueList = styled('ul')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(0.5),
  margin: 0,
  paddingInlineStart: theme.spacing(2.5),
}));

export const SummaryDashboardEditDialogEmpty = styled('p')(({ theme }) => ({
  color: theme.palette.neutral[500],
  fontSize: 'var(--dialog-description-font-size)',
  lineHeight: 'var(--dialog-description-line-height)',
  margin: 0,
}));
